import React from "react";
import { ProjectsTableContainer } from "../../components/ProjectsTable";

export const ProjectOverviewPage = () => {
  return <ProjectsTableContainer />;
};
